import React, { memo, useCallback } from 'react'
import { useAppDispatch } from 'Src/hooks'
import { ComponentPropsModalUnsignedOrders, modalsSlice } from 'Modules'
import { authSlice } from 'Pages/auth'
import { useHistory } from 'react-router-dom'
import { MODAL_NAME } from 'Constants/ModalName'
import { FrontUrls } from 'Constants/FrontUrls'
import { FilterBtnType } from 'Pages/orders_design'
import { BtnComponent, Heading } from 'LibNeo'
import {
	BodyTwoStyle,
	UnsignedOrdersHeaderStyle,
	UnsignedOrdersIconCloseStyle,
	UnsignedOrdersModalStyle,
	UnsignedOrdersTextStyle,
} from './styled'

export const ModalUnsignedOrdersComponent = memo<ComponentPropsModalUnsignedOrders>(
	({ id, unsigned_order_ids }) => {
		const { hideModal, updateUser } = useAppDispatch({
			hideModal: modalsSlice.actions.hideModal,
			updateUser: authSlice.actions.updateUser,
		})

		const history = useHistory()
		const onSubmit = useCallback((): void => {
			hideModal(MODAL_NAME.UNSIGNED_ORDERS)
			updateUser({ id, unsigned_order_ids })
			history.push(FrontUrls.orders_redesign.index, { filter: FilterBtnType.INCOMPLETED })
		}, [id, unsigned_order_ids])

		return (
			<UnsignedOrdersModalStyle>
				<UnsignedOrdersHeaderStyle>
					<Heading type="h5">Работа над заявками</Heading>
					<UnsignedOrdersIconCloseStyle
						name="close"
						onClick={() => hideModal(MODAL_NAME.UNSIGNED_ORDERS)}
					/>
				</UnsignedOrdersHeaderStyle>
				<UnsignedOrdersTextStyle>
					<BodyTwoStyle>
						Мы заметили, что есть несколько заявок, по которым заявления на «Торговый эквайринг» или
						«Смарт-терминал» не подписаны Вашими клиентами в Интернет-банке Сбербизнес!
					</BodyTwoStyle>
					<BodyTwoStyle>
						Напомните вашим клиентам о необходимости подписания документа и дождитесь учета сделки.
					</BodyTwoStyle>
				</UnsignedOrdersTextStyle>
				<BtnComponent title="modals.unsigned_orders.button" onClick={onSubmit} />
			</UnsignedOrdersModalStyle>
		)
	}
)
